import template from './add_new_holiday_type.html';
import tr from '../../lib/default-translator.js';

class AdminAddNewHolidayTypeViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.selected_hexcolor = ko.observable();
		this.holiday_type = ko.observable();
		this.description = ko.observable();
		this.colors = ko.observableArray();
	};

	async save_holiday_type()
	{
		let post_url = '/admin/save_holiday_type';

		if (this.selected_hexcolor() == 'undefined' || this.selected_hexcolor() == null)
			this.selected_hexcolor('#CCCCCC');

		let obj = {
			holiday_type: this.holiday_type(),
			hexcolor: this.selected_hexcolor(),
			description: this.description()
		};
		
		//Validation on holiday type and description
		let valid = true;
		let msg = '';
		
		if (!obj.holiday_type)
		{
			valid = false;
			msg = tr('Please add a holiday type.');
		}
		else if (!obj.description)
		{
			valid = false;
			msg = tr('Please add a description'); 
		}

		if (valid == true)
		{
			let res = await Grape.fetches.postJSON(post_url, obj);
			if (res.status == 'OK')
			{
				if (!this.dialog.bindings.wizard)
				{ 
					let success = tr('Successfully saved holiday type. Please link the holiday type to a leave type for it to be effective.');
					await Grape.alerts.alert({type: 'success', message: tr(success, success), title: tr('Success', 'Success')});
					localStorage.setItem('holiday_type_selected', obj.holiday_type);
					this.dialog.close();
				}
				else
				{
					let success = tr('Successfully saved holiday type'); 
					await Grape.alerts.alert({type: 'success', message: tr(success, success), title: tr('Success', 'Success')});
					this.dialog.close({holiday_type: this.holiday_type()});
				}
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		 }
		 else
			Grape.alerts.alert({ type: 'error', message: msg, title: tr('Validation Error')});
	};

	close()
	{
		this.dialog.close(true);
	}
};

class AdminAddNewHolidayTypePage
{
	constructor (bindings)
	{
		this.viewModel = new AdminAddNewHolidayTypeViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		try {
			let options = {
				table: 'colors',
				limit: 100
			}
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				this.viewModel.colors(res.records);
				this.viewModel.selected_hexcolor(res.records[0].hexcolor);
			}
		} catch (error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		this.formatSelect();
	}

	formatSelect()
	{
		let div = window.document.getElementById('select-color');
		let select = document.createElement('select');
		select.classList.add('ps-input');
		this.viewModel.colors().forEach(color => {
			let option = document.createElement('option');
			option.value = color.hexcolor;
			option.textContent = color.name;
			option.style.backgroundColor = color.hexcolor;
			option.style.color = '#ffffff';
			select.appendChild(option);
			option.classList.add('color-select-option');
		});
	
		div.appendChild(select);
	
		select.addEventListener('change', () => {
			this.viewModel.selected_hexcolor(select.value);
		});
	};
};

export default {
	name: 'AdminAddNewHolidayType',
	dialog_class: AdminAddNewHolidayTypePage,
	template: template,
	template_filename: 'translation/dialogs/add_new_holiday_type',
	provider: 'ps'
};
